import { render, staticRenderFns } from "./ProductLoad.vue?vue&type=template&id=768c4baa&scoped=true"
import script from "./ProductLoad.vue?vue&type=script&lang=js"
export * from "./ProductLoad.vue?vue&type=script&lang=js"
import style0 from "./ProductLoad.vue?vue&type=style&index=0&id=768c4baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c4baa",
  null
  
)

export default component.exports